export const siteConfig = {
  siteName: '导航页在线发布',
  siteDescription: '导航页在线发布平台，无需编程基础，轻松创建并在线发布你的专属导航页。支持自定义分类、链接管理、一键部署。',
  siteUrl: 'https://daohangye.com',
  siteKeywords: '导航页在线发布,在线发布导航页工具,自定义导航页制作,导航页一键部署,免费导航页搭建,网址导航页发布,导航页在线托管',
  locale: 'zh-CN',
  author: '导航页在线发布团队',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '功能特性', href: '/#features' },
  { label: '使用教程', href: '/category/tutorial' },
  { label: '方案价格', href: '/#pricing' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  product: [
    { label: '功能特性', href: '/#features' },
    { label: '模板展示', href: '/#templates' },
    { label: '方案价格', href: '/#pricing' },
    { label: '更新日志', href: '/category/updates' },
  ],
  support: [
    { label: '使用教程', href: '/category/tutorial' },
    { label: '常见问题', href: '/#faq' },
    { label: '帮助中心', href: '/category/help' },
    { label: '联系我们', href: '/about#contact' },
  ],
  company: [
    { label: '关于我们', href: '/about' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '合作联系', href: '/about#contact' },
    { label: '隐私政策', href: '/article/privacy' },
  ],
};